import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isSuperAdmin } from '../../../utils/auth/currentUser';
import FeatureFlagsAccessDenied from '../components/FeatureFlagsAccessDenied';
import FeatureFlagsPageContent from '../components/FeatureFlagsPageContent';

const FeatureFlagsPage: React.FC = () => {
  const navigate = useNavigate();
  const handleBackToStores = React.useCallback(() => {
    navigate('/dashboard/store-summary');
  }, [navigate]);

  return isSuperAdmin() ? <FeatureFlagsPageContent /> : <FeatureFlagsAccessDenied onBack={handleBackToStores} />;
};

export default FeatureFlagsPage;
